import {
  Space,
  FormProps, Button, Form, Input, Typography, App
} from "antd";
import { useMutation } from "@apollo/client";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RESET_PASSWORD } from "./resetPassword.gql";
import { appRoutes } from "../../constants/routes";

const { Title } = Typography;

type FieldType = {
  email?: string;
};

const ResetPassword = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [resetPwdForm] = Form.useForm();
  const [resetPassword, { loading }] = useMutation(
    RESET_PASSWORD,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        resetPwdForm.resetFields();
        navigate(appRoutes.login);
        message.info("Ti abbiamo spedito una mail per il reset della password");
      }
    },
  );

  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    resetPassword({ variables: { email: values.email } });
  };

  return (
    <div style={{ maxWidth: 459, width: "100%" }}>
      <Space direction="vertical" style={{ marginBottom: 43, textAlign: "center", width: "100%" }}>
        <Title level={2} style={{ marginBottom: 0 }}>{t("resetPasswordPage.title")}</Title>
        <Title level={4} style={{ margin: 0 }}>
          {t("resetPasswordPage.subtitle")}
        </Title>
      </Space>
      <Form
        form={resetPwdForm}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        style={{ maxWidth: 459, width: "100%" }}
      >
        <Form.Item
          name="email"
          rules={[{ required: true, message: t("form.error.email") }]}
        >
          <Input
            prefix={<UserOutlined style={{ color: "rgba(0,0,0,.45)" }}/>}
            placeholder="email"
            value=""
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            disabled={loading}
          >
            {t("resetPasswordPage.button")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPassword;
